<template>
  <div class="reset-password-form">
    <h1>Vytvořit nový přístup - obnova zapomenutého hesla</h1>
    <hr>
    <form class="form-horizontal" autocomplete="off" v-if="showForm" @submit.prevent="noOp()">
      <div class="form-group row">
        <label for="inputUsername" class="col-sm-2 control-label">
          <nobr>Vím klientské číslo</nobr>
          </label>
        <div class="col-sm-4">
          <input type="text" ref="username" name="username" class="form-control"
            v-model="inputUsername" placeholder="1012233" :disabled="submitPending"
            v-validate="'numeric|min:7'" maxlength="10"
            :class="{'is-danger': errors.has('username') }"
            autofocus
          >
          <span v-show="errors.has('username')" class="help is-danger">Vložte prosím 7místné klientské číslo</span>
        </div>
        <div class="col-sm-4">
          Klientské číslo je sedmimístné, např. 1012233.
          Odpovídá variabilnímu symbolu, který používáte pro platby trvalým příkazem za služby
          společnosti Rychlý drát, s.r.o. Na výpisu z Vaší banky jej najdete
          u odchozích plateb ve prospěch účtu 344355366/2010.
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-2 control-label" />
        <div class="col-sm-4">
          <button v-on:click="submitUsername" class="btn btn-primary"
            :disabled="submitPending || errors.has('username') || inputUsername == ''">
            <span v-if="submitPending != 1">Pokračovat</span>
            <i v-if="submitPending == 1" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </form>
    <hr>
    <form class="form-horizontal" autocomplete="off" v-if="showForm" @submit.prevent="noOp()">
      <div class="form-group row">
        <label for="inputEmail" class="col-sm-2 control-label">
          <nobr>Vím e-mail</nobr>
        </label>
        <div class="col-sm-4">
          <input type="text" name="email" class="form-control" v-model="inputEmail" placeholder="jmeno@example.com" :disabled="submitPending"
            v-validate="'email'"
            :class="{'is-danger': errors.has('email') }"
          >
          <span v-show="errors.has('email')" class="help is-danger">Vložte prosím platnou e-mail adresu</span>
        </div>
        <div class="col-sm-4">
          Zadejte e-mail adresu, kterou jste vyplnili do smlouvy o poskytnutí telekomunikačních služeb
          se společností Rychlý drát, s.r.o.
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-2 control-label" />
        <div class="col-sm-4">
          <button v-on:click="submitEmail" class="btn btn-primary"
            :disabled="submitPending || errors.has('email') || inputEmail == ''">
            <span v-if="submitPending != 2">Pokračovat</span>
            <i v-if="submitPending == 2" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </form>

    <div class="form-group" v-if="displayError">
      <div class="col-sm-10 error-box">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        {{ displayError }}
      </div>
    </div>
    <div class="form-group" v-if="showStep2a">
      <div class="col-sm-10">
         Na adresu {{ this.displayEmails }} jsme odeslali e-mail s instrukcemi pro nastavení nového hesla.
      </div>
      <div class="col-sm-10 blue-box">
        Klikněte na odkaz, který najdete v e-mailu.
      </div>
    </div>
  </div>
</template>

<script>
import SessionResource from '../backend-resources/session-resource'

export default {
  name: 'reset-password-component',
  data: () => {
    return {
      showForm: true,
      showStep2a: false,
      inputUsername: '',
      inputEmail: '',
      submitPending: false,
      displayError: null,
      displayEmails: ''
    }
  },
  methods: {
    submitUsername () {
      this.submitPending = 1
      this.submitResetPassword({knownUsername: this.inputUsername})
    },
    submitEmail () {
      this.submitPending = 2
      this.submitResetPassword({knownEmail: this.inputEmail})
    },
    submitResetPassword (knownInputs) {
      this.displayError = null
      let sr = new SessionResource()
      sr.resetPassword(knownInputs).then((response) => {
        this.showStep2a = true
        this.showForm = false
        this.submitPending = false
        this.displayEmails = response.data.emails.join()
      })
      .catch((error) => {
        this.submitPending = false
        if (error.response && error.response.status === 404) {
          this.displayError = 'Zadané klientské číslo a/nebo e-mail nebyly nalezeny'
        } else if (error.response && error.response.status === 409) {
          this.displayError = 'Zadaný e-mail je použit pro více zákazníků, prosíme kontaktujte nás telefonicky'
        } else if (error.response && error.response.status) {
          this.displayError = error.response.status + ' ' + error.response.statusText
        } else {
          this.displayError = error.toString()
        }
      })
    },
    noOp () {}
  },
  created: function () {
    setTimeout(() => {
      this.$refs.username.focus()
    }, 100)
  }
}
</script>

<style scoped>
.reset-password-form {
  max-width: 1000px;
  padding: 3rem 1rem;
  border-color: #e5e5e5 #eee #eee;
  border-style: solid;
  border-width: 1px 0;
  border-radius: 4px 4px 4px 4px;
  -webkit-box-shadow: inset 0 3px 6px rgba(0,0,0,.05);
          box-shadow: inset 0 3px 6px rgba(0,0,0,.05);
}
button {
  width: 100%;
}
.is-danger {
  border-color: #ff3860;
}
.help {
  display: block;
  font-size: 11px;
  margin-top: 5px;
  color: #ff3860;
}
.blue-box {
  border-width: 1px;
  border-color: #539ac7;
  border-style: solid;
  padding: 10px;
}
h1 {
  text-transform: uppercase;
  font-size: 18px;
}
.old-account-number {
  color: gray;
  text-decoration-line: line-through;
}
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?00018ce6